export default {
  Module: [],
  Caption: "",
  Type: "Text",
  Value: "",
  ListOfValues: [],
  Active: true,
  UserModified: localStorage.getItem("UserName"),
};
